'use client';

import {CSSProperties} from "react";

// TODO: contain and cover exclude through common type, fitParent : height | width | both
export type TageaImageProps = {
    src?: string,
    alt: string,
    fitParentHeight?: boolean,
    fitParentWidth?: boolean,
    fitParent?: boolean,
    width?: number,
    height?: number,
    contain?: boolean,
    cover?: boolean,
    style?: CSSProperties
}

export const TageaImage = ({src, alt, fitParentHeight, fitParentWidth, fitParent, width, height, contain=true, cover, style}: TageaImageProps) => {

    const isContain = contain && !cover

    const objectFitStyle = isContain ? "contain" : "cover"
    const _style: CSSProperties = {
        objectFit: objectFitStyle,
        ...style
    }

    if(width && height) {
        _style.width = width
        _style.height = height
    } else if (fitParentHeight) {
        _style.height = "100%"
    } else if (fitParentWidth) {
        _style.width = "100%"
    }  else if(fitParent) {
        _style.maxHeight = "100%"
        _style.maxWidth = "100%"
    } else if (width){
        _style.width = width
    } else if (height) {
        _style.height = height
    } else {
        _style.width = "100%"
        _style.height = "100%"
    }

    return (
        <img alt={alt} style={_style} src={src} />
    )
}


